/** @jsxImportSource @emotion/react */
import css from '@emotion/css/macro'
import { SkeletonRow } from 'src/components/ts-components/SkeletonBlock'

const ROWS = 3

/** Stands in for a key/token grid on first load: header row plus a few rows. */
export const ApiAccessSkeleton = () => (
  <div css={wrapStyle} aria-hidden='true'>
    <SkeletonRow height={32} />
    {Array.from({ length: ROWS }, (_, row) => (
      <SkeletonRow key={row} />
    ))}
  </div>
)

const wrapStyle = css`
  display: flex;
  flex-direction: column;
  gap: 8px;
`
